export function isLocalDevelopmentHost(hostname = window.location.hostname, isDevelopmentBuild = import.meta.env.DEV): boolean {
  return isDevelopmentBuild || hostname === "qa.test" || hostname.endsWith(".localhost")
}
